import React from 'react';
import { CtaButton } from './CtaButton';
import { checkoutUrl, offer, pricingRows } from '../data/content';
export function Pricing() {
  return <section id="planes" className="w-full bg-white py-16 md:py-24" data-id="element-108" data-mp="2ar2ea9wnokl1">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-109" data-mp="2ohnxjzq0uwjg">
        <h2 className="mx-auto max-w-xl text-center font-display text-[2rem] font-extrabold leading-[1.08] tracking-tight text-ink md:text-5xl" data-id="element-110" data-mp="2jjw7lb8xtkhw">
          Oferta especial de lanzamiento
        </h2>

        <div className="relative mx-auto mt-14 max-w-xl rounded-3xl bg-white px-6 pb-8 pt-10 ring-2 ring-blue-600 md:px-10 md:pb-10" data-id="element-111" data-mp="1rsq2eged0wlr">
          <p className="absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2 whitespace-nowrap rounded-full bg-blue-600 px-5 py-1.5 font-display text-xs font-extrabold uppercase tracking-[0.16em] text-white" data-id="element-112" data-mp="25t0ufmreoh8i">
            Sistema completo
          </p>

          <dl className="divide-y divide-blue-100" data-id="element-113" data-mp="3c8jwrhwt4u0q">
            {pricingRows.map(row => <div key={row.label} className="flex items-start justify-between gap-6 py-4" data-id="element-114" data-mp="3vzgsnq5g94xt">
                <dt className="text-ink" data-id="element-115" data-mp="4t5lrddrd9yk">{row.label}</dt>
                <dd className="shrink-0 font-display font-extrabold text-blue-700" data-id="element-116" data-mp="4rum9prciod9">{row.value}</dd>
              </div>)}
            <div className="flex items-center justify-between gap-6 py-4" data-id="element-117" data-mp="9qe71mu7du41">
              <dt className="font-display text-sm font-extrabold uppercase tracking-[0.14em] text-ink" data-id="element-118" data-mp="eqtkeeehj1m0">
                Valor total:
              </dt>
              <dd className="shrink-0 font-display font-extrabold text-blue-900/55 line-through" data-id="element-119" data-mp="3i7iprx2c05a3">
                {offer.totalValue}
              </dd>
            </div>
          </dl>

          <div className="mt-6 text-center" data-id="element-120" data-mp="3rxv8rkuhzqe4">
            <p className="font-display text-xs font-extrabold uppercase tracking-[0.18em] text-blue-600" data-id="element-121" data-mp="3ryn3ktg9tk3c">
              Precio de lanzamiento
            </p>
            <p className="mt-2 font-display text-7xl font-extrabold leading-none tracking-tight text-blue-600 md:text-8xl" data-id="element-122" data-mp="2zharptdho50r">
              {offer.price}
            </p>
            <p className="mt-2 text-sm font-semibold text-blue-900/60" data-id="element-123" data-mp="2res1o6qdswxx">
              Valor regular <span className="line-through" data-id="element-124" data-mp="2mhi2w0h3r8xf">{offer.listPrice}</span> ARS
            </p>
          </div>

          <div className="mt-8 border-t border-blue-100 pt-7" data-id="element-125" data-mp="315weazsl45pl">
            <p className="text-center text-sm text-blue-900/75" data-id="element-126" data-mp="2w8mhgz2v8rrq">
              Pago único, acceso de por vida. Sin suscripción.
            </p>
            <div className="mt-5" data-id="element-127" data-mp="28k3acmvjyl18">
              <CtaButton size="lg" className="w-full" href={checkoutUrl} data-id="element-128" data-mp="23jfjc17bq470">
                {offer.cta}
              </CtaButton>
            </div>
            <p className="mt-4 text-center text-sm text-blue-900/60" data-id="element-129" data-mp="2ihre22b4z2vj">
              Acceso inmediato · Pago único · Uso de por vida · Garantía de 7 días
            </p>
          </div>
        </div>
      </div>
    </section>;
}